const LOG_TYPES = new Set(["log", "log_image", "error"]);

export function filterEvents(events, mode) {
  return events.filter((event) => {
    if (mode === "logs_only") return LOG_TYPES.has(event.type);
    if (mode === "important")
      return !event.type.startsWith("workflow") && event.type !== "ui_detect_result";
    return true;
  });
}
